// Route: '/lobby/:sessionid/:gameid/:playerid'
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Nav from '../../components/Nav/Nav';
import {
  MainContainer, Container, TextContainer,
  StartButton, NameContainer, PlayerNum,
  PlayerContainer
} from './LobbyPage.styles';
import useInterval from 'use-interval';
import { BsPersonFill } from 'react-icons/bs';
import { StoreContext } from '../../utils/store';

const LobbyPage = () => {
  const { sessionid, gameid, playerid } = useParams();
  const context = useContext(StoreContext);
  const [api] = context.api;
  const [, setModalStatus] = context.modalStatus;
  const history = useHistory();

  const [isAdmin, setIsAdmin] = useState(false);
  const [advanced, setAdvanced] = useState(false);

  // admin results state
  const [results, setResults] = useState({});

  // api call functions
  const getAdminStatus = async () => {
    const response = await api.makeAPIRequest(`admin/session/${sessionid}/status`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      return response;
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  const advanceGame = async () => {
    const response = await api.makeAPIRequest(`admin/quiz/${gameid}/advance`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        setAdvanced(true);
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  // get player status
  const getStatus = async () => {
    const response = await api.makeAPIRequest(`play/${playerid}/status`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        return json.started;
      } else {
        setModalStatus((status) => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  // player id 0 identifies admin
  useEffect(async () => {
    if (localStorage.getItem('token') && playerid === '0') {
      const r = await getAdminStatus();
      const j = await r.json();
      const newResults = j.results;
      console.log(newResults);
      if (r.status === 200) {
        setIsAdmin(true);
        if (newResults.position >= 0 && newResults.position < newResults.questions.length) {
          history.push(`/play/${sessionid}/${gameid}/${playerid}`);
        }
      }
      setResults(newResults);
    }
  }, [advanced]);

  // player poll
  useInterval(
    async () => {
      if (playerid !== '0') {
        const started = await getStatus();
        console.log('game started:', started);
        if (started) {
          history.push(`/play/${sessionid}/${gameid}/${playerid}`);
        }
      } else {
        const r = await getAdminStatus();
        const j = await r.json();
        const newResults = j.results;
        setResults(newResults);
      }
    },
    500
  );

  return (
    <>
      <Container>
        <Nav
          visibilities={['false', 'false', 'false', 'true', 'false']}
          exit={() => history.push('/')}
        />
        <MainContainer>
          {isAdmin
            ? <>
              {results &&
                <>
                {results.players &&
                  <PlayerNum>
                    <span><BsPersonFill /></span>
                    <span>{results.players.length}</span>
                  </PlayerNum>
                }
                </>
              }
              <StartButton
                onClick={advanceGame}>
                Start
              </StartButton>
              <PlayerContainer>
                {results.players &&
                  <>
                  {results.players.map((p, idx) => (
                    <NameContainer key={idx}>
                      <span >{p}</span>
                    </NameContainer>

                  ))}
                  </>
                }
              </PlayerContainer>
              </>
            : <TextContainer>
                <h1>You&apos;re in!</h1>
                <p>See your nickname on screen?</p>
              </TextContainer>
          }
        </MainContainer>
      </Container>
    </>
  );
};

export default LobbyPage;
